import { QueryClientProvider } from "@tanstack/react-query";
import { PropsWithChildren, useEffect } from "react";
import { setClientGlobalConfig } from "../client";
import { putUsersMe } from "../generated";
import { queryClient } from "../queryClient";

type ClientApiProviderProps = PropsWithChildren<{
  authToken?: string;
  baseURL?: string;
}>;

export function ClientApiProvider({
  authToken,
  baseURL,
  children,
}: ClientApiProviderProps) {
  setClientGlobalConfig({ authToken, baseURL });

  useEffect(() => {
    // Silently update user information every time the user is authenticated,
    // to ensure that the user information is up-to-date.
    async function updateUserInformation() {
      try {
        await putUsersMe();
        // eslint-disable-next-line no-empty
      } catch {}
    }

    if (authToken) {
      updateUserInformation();
    }
  }, [authToken]);

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
